import { Maybe, PriceListHighlights } from 'src/types';
import { CurrentCampaign, PriceDisplay } from '../../types';

export interface IHighlightedOffersProps {
  productId: number;
  categoryId: string | undefined;
  highlights: PriceListHighlights;
  campaign: Maybe<CurrentCampaign> | undefined;
  priceDisplay: PriceDisplay;
}

export enum HighlightedOfferType {
  Recommended,
  Cheapest,
  Fastest,
  Promoted,
  PromotedLarge,
  PromotedStandalone,
}
